<template>
  <div class="h-screen flex overflow-hidden bg-bg-primary">
    <!-- Off-canvas menu for mobile, show/hide based on off-canvas menu state. -->

    <!-- Static sidebar for desktop -->
    <aside id="sidebar" class="hidden md:flex md:flex-shrink-0 z-30">
      <div class="flex flex-col w-64">
        <!-- Sidebar menu -->

        <div class="flex-1 flex flex-col min-h-0 border-r border-gray-200 bg-white">
          <div class="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
            <div class="flex items-center flex-shrink-0 px-4">
              <img class="h-8 w-auto" src="https://tailwindui.com/img/logos/workflow-logo-indigo-600-mark-gray-800-text.svg" alt="Workflow" />
            </div>
            <nav class="mt-5 flex-1 px-2 bg-white space-y-1" aria-label="MainMenu">
              <ol>
                <li v-for="menuItem in mainMenu" v-bind:key="menuItem">
                  <router-link v-if="!menuItem.submenu && menuItem.routeName" :to="{ name: menuItem.routeName }" class="text-gray-900 mb-1 hover:text-gray-900 hover:bg-gray-100 group flex items-center px-2 py-2 text-sm font-medium rounded-md">
                    <img :src="menuItem.svg" class="text-gray-500 mr-3 flex-shrink-0 h-6 w-6" />
                    <span class="flex-1">{{ $t(menuItem.name) }} </span>
                  </router-link>
                  <div v-else-if="menuItem.submenu" class="rounded-md mb-1" :class="{ ' outline-none ring-2 ring-indigo-500': menuItem.isOpen }">
                    <button v-on:click="toggleSubmenu(menuItem.name)" type="button" class="bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-900 group w-full flex items-center pl-2 pr-1 py-2 text-left text-sm font-medium rounded-md focus:outline-none" aria-controls="sub-menu-1" aria-expanded="false">
                      <img :src="menuItem.svg" class="text-gray-500 mr-3 flex-shrink-0 h-6 w-6" />

                      <span class="flex-1">{{ $t(menuItem.name) }}</span>
                      <svg :class="{ 'rotate-90': menuItem.isOpen }" class="text-gray-300 ml-3 flex-shrink-0 h-5 w-5 transform group-hover:text-gray-400 transition-colors ease-in-out duration-150" viewBox="0 0 20 20" aria-hidden="true">
                        <path d="M6 6L14 10L6 14V6Z" fill="currentColor" />
                      </svg>
                    </button>
                    <ol v-if="menuItem.isOpen" class="space-y-1" id="sub-menu-1">
                      <li v-for="submenu in menuItem.submenu" v-bind:key="submenu">
                        <router-link v-if="submenu.routeName" :to="{ name: submenu.routeName }" class="group w-full flex items-center pl-11 pr-2 py-2 text-sm font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50">
                          <span class="flex-1">{{ $t(submenu.name) }}</span>
                          <span v-if="submenu.badge" class="bg-indigo-600 text-gray-100 ml-3 inline-block py-0.5 px-2.5 text-xs font-semibold rounded-full"> {{ submenu.badge.content || "?" }} </span>
                        </router-link>
                        <span v-else class="cursor-not-allowed group w-full flex items-center pl-11 pr-2 py-2 text-sm font-medium text-gray-400 rounded-md hover:text-gray-600"> {{ $t(submenu.name) }} </span>
                      </li>
                    </ol>
                  </div>
                  <div v-else class="text-gray-900 hover:text-gray-900 hover:bg-gray-100 group flex items-center px-2 py-2 text-sm font-medium rounded-md">
                    <img :src="menuItem.svg" class="text-gray-500 mr-3 flex-shrink-0 h-6 w-6" />
                    <span class="flex-1"> {{ $t(menuItem.name) }} </span>
                  </div>
                </li>
              </ol>
            </nav>
          </div>
          <div class="px-5 py-4 w-full">
            <div>
              <div class="mt-1 relative">
                <button v-on:click="changeCompany.isOpen = !changeCompany.isOpen" type="button" :class="{ 'outline-none ring-1 ring-indigo-500 border-indigo-500': changeCompany.isOpen }" class="bg-white transition duration-300 inline-flex relative w-full h-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left sm:text-sm">
                  <span class="my-auto">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </span>
                  <span class="pl-4 flex flex-col w-full pr-4">
                    <p class="block truncate">Webits Aps asd</p>
                    <p class="block truncate">41336404</p>
                  </span>

                  <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                    <!-- Heroicon name: solid/selector -->
                    <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd" d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                  </span>
                </button>

                <div style="transform: translate(0px, -70px)">
                  <transition name="slide-up">
                    <div v-if="changeCompany.isOpen" v-click-away="changeCompanyIsOpen" style="inset: auto auto 0px 0px; box-shadow: rgb(38 40 47 / 35%) 0px 10px 70px" class="w-72 rounded-md bg-white p-2 absolute">
                      <input-with-icon v-model="changeCompany.searchField" v-bind="changeCompany.form.attrs"></input-with-icon>
                      <ul class="bg-white max-h-60 rounded-md text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm" tabindex="-1" role="listbox" aria-labelledby="listbox-label" aria-activedescendant="listbox-option-3">
                        <li class="text-gray-900 cursor-default select-none relative py-2 pl-3 pr-9" id="listbox-option-0" role="option">
                          <span class="font-normal block truncate"> Wade Cooper </span>
                          <span class="text-indigo-600 absolute inset-y-0 right-0 flex items-center pr-4">
                            <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                              <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                            </svg>
                          </span>
                        </li>
                        <li class="text-gray-900 cursor-default select-none relative py-2 pl-3 pr-9" id="listbox-option-0" role="option">
                          <span class="font-normal block truncate"> Wade Cooper </span>
                          <span class="text-indigo-600 absolute inset-y-0 right-0 flex items-center pr-4">
                            <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                              <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                            </svg>
                          </span>
                        </li>
                      </ul>
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </div>
          <ul class="flex justify-between px-8 pb-4">
            <li>
              <button class="text-gray-600 hover:text-gray-900 hover:bg-gray-50">
                <!-- Heroicon name: outline/logout -->
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
              </button>
            </li>
            <li class="m-auto">
              <button class="text-gray-600 hover:text-gray-900 hover:bg-gray-50">
                <!-- Heroicon name: outline/cog -->
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                  />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </button>
            </li>
            <li>
              <button class="text-gray-600 hover:text-gray-900 hover:bg-gray-50">
                <!-- Heroicon name: outline/information-circle -->
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </aside>
    <div class="flex flex-col w-0 flex-1 overflow-hidden">
      <header class="relative flex-shrink-0 flex h-16 bg-white shadow z-30">
        <button type="button" class="px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 md:hidden">
          <span class="sr-only">Open sidebar</span>
          <!-- Heroicon name: outline/menu-alt-2 -->
          <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h7" />
          </svg>
        </button>
        <div class="flex-1 px-4 flex justify-between">
          <div class="flex-1 flex">
            <h1 class="my-auto">
              <slot name="title"> </slot>
            </h1>
          </div>
          <div class="ml-4 flex items-center md:ml-6">
            <form class="w-full flex md:ml-0" action="#" method="GET">
              <label for="search-field" class="sr-only">Search</label>
              <div class="relative w-full text-gray-400 focus-within:text-gray-600">
                <div class="absolute inset-y-0 left-0 flex items-center pointer-events-none">
                  <!-- Heroicon name: solid/search -->
                  <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd" />
                  </svg>
                </div>
                <input id="search-field" class="block w-full h-full pl-8 pr-3 py-2 border-transparent text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-indigo-500 focus:placeholder-gray-400 focus:ring-0 focus:border-transparent sm:text-sm" placeholder="Search" type="search" name="search" />
              </div>
            </form>
            <button type="button" class="bg-white ml-2 p-1 rounded-full text-gray-400 hover:text-gray-500 focus:text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
              <span class="sr-only">View notifications</span>
              <!-- Heroicon name: outline/bell -->
              <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
              </svg>
            </button>

            <!-- Profile dropdown -->
            <div class="ml-3 w-12 relative">
              <div>
                <button v-on:click="profileMenu.isOpen = !profileMenu.isOpen" type="button" :class="{ 'ring-offset-2 ring-indigo-500 ring-2': profileMenu.isOpen }" class="max-w-xs bg-white flex items-center text-sm rounded-full focus:outline-none transition duration-300">
                  <span class="sr-only">Open user menu</span>
                  <img class="h-8 w-8 rounded-full" src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="" />
                </button>
              </div>
              <transition name="slide-down">
                <div v-if="profileMenu.isOpen" v-click-away="profileMenuIsOpen" class="z-30 origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-200 focus:outline-none">
                  <div class="px-4 py-3">
                    <p class="text-sm">Signed in as</p>
                    <p class="text-sm font-medium text-gray-900 truncate">tom@example.com</p>
                  </div>
                  <div v-for="menuGroup in profileMenu.menuItemGroup" :key="menuGroup">
                    <div v-for="menuItem in menuGroup.group" :key="menuItem">
                      <router-link v-if="menuItem.routeName" :to="{ name: menuItem.routeName }" v-on:click="profileMenuIsOpen" class="text-gray-700 group flex items-center px-4 py-3 text-sm">
                        <!-- Heroicon name: solid/pencil-alt -->
                        <svg class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                          <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
                          <path fill-rule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clip-rule="evenodd" />
                        </svg>
                        {{ $t(menuItem.name) }}
                      </router-link>
                      <a v-else-if="menuItem.outgoingLink" :target="menuItem.outgoingLinkIsBlank ? '_blank' : '_self'" :href="menuItem.outgoingLink" class="text-gray-700 group flex items-center px-4 py-3 text-sm hover:bg-gray-100">
                        <!-- Heroicon name: solid/pencil-alt -->
                        <svg class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                          <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
                          <path fill-rule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clip-rule="evenodd" />
                        </svg>
                        {{ $t(menuItem.name) }}
                      </a>
                      <span v-else class="text-gray-700 group flex items-center px-4 py-3 text-sm">
                        <!-- Heroicon name: solid/pencil-alt -->
                        <svg class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                          <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
                          <path fill-rule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clip-rule="evenodd" />
                        </svg>
                        {{ $t(menuItem.name) }}
                      </span>
                    </div>
                  </div>
                  <div>
                    <span v-on:click="langMenu.isOpen = !langMenu.isOpen" class="text-gray-700 group flex items-center px-4 py-3 text-sm hover:bg-gray-100 rounded-b-md">
                      <!-- Heroicon name: outline/translate -->
                      <svg class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
                      </svg>
                      {{ $t("profile-menu.language") }}
                    </span>
                    <div style="transform: translate(-128px, -48px)">
                      <transition name="slide-right-left">
                        <ul v-if="langMenu.isOpen" v-click-away="toggleLangMenu" class="absolute inset-x-0 z-10 mt-1 w-32 bg-white shadow-lg max-h-56 rounded-md text-base overflow-auto focus:outline-none sm:text-sm">
                          <li v-on:click="changeLang('da')" :class="{ 'lang-active': this.$i18n.locale == 'da' }" class="text-gray-900 hover:bg-gray-100 select-none relative py-3 px-4 cursor-pointer" id="listbox-option-0" role="option">
                            <div class="flex items-center">
                              <svg class="flex-shrink-0 h-6 w-6 rounded-md" xmlns="http://www.w3.org/2000/svg" id="flag-icon-css-dk" viewBox="0 0 640 480">
                                <path fill="#c8102e" d="M0 0h640.1v480H0z" />
                                <path fill="#fff" d="M205.7 0h68.6v480h-68.6z" />
                                <path fill="#fff" d="M0 205.7h640.1v68.6H0z" />
                              </svg>
                              <!-- Selected: "font-semibold", Not Selected: "font-normal" -->
                              <span class="font-normal ml-3 block truncate"> Danish </span>
                            </div>
                          </li>
                          <li v-on:click="changeLang('en')" :class="{ 'lang-active': this.$i18n.locale == 'en' }" class="text-gray-900 hover:bg-gray-100 cursor-pointer select-none relative py-2 pl-3">
                            <div class="flex items-center">
                              <svg class="flex-shrink-0 h-6 w-6 rounded-md" xmlns="http://www.w3.org/2000/svg" id="flag-icon-css-us" viewBox="0 0 640 480">
                                <g fill-rule="evenodd">
                                  <g stroke-width="1pt">
                                    <path fill="#bd3d44" d="M0 0h972.8v39.4H0zm0 78.8h972.8v39.4H0zm0 78.7h972.8V197H0zm0 78.8h972.8v39.4H0zm0 78.8h972.8v39.4H0zm0 78.7h972.8v39.4H0zm0 78.8h972.8V512H0z" transform="scale(.9375)" />
                                    <path fill="#fff" d="M0 39.4h972.8v39.4H0zm0 78.8h972.8v39.3H0zm0 78.7h972.8v39.4H0zm0 78.8h972.8v39.4H0zm0 78.8h972.8v39.4H0zm0 78.7h972.8v39.4H0z" transform="scale(.9375)" />
                                  </g>
                                  <path fill="#192f5d" d="M0 0h389.1v275.7H0z" transform="scale(.9375)" />
                                  <path
                                    fill="#fff"
                                    d="M32.4 11.8L36 22.7h11.4l-9.2 6.7 3.5 11-9.3-6.8-9.2 6.7 3.5-10.9-9.3-6.7H29zm64.9 0l3.5 10.9h11.5l-9.3 6.7 3.5 11-9.2-6.8-9.3 6.7 3.5-10.9-9.2-6.7h11.4zm64.8 0l3.6 10.9H177l-9.2 6.7 3.5 11-9.3-6.8-9.2 6.7 3.5-10.9-9.3-6.7h11.5zm64.9 0l3.5 10.9H242l-9.3 6.7 3.6 11-9.3-6.8-9.3 6.7 3.6-10.9-9.3-6.7h11.4zm64.8 0l3.6 10.9h11.4l-9.2 6.7 3.5 11-9.3-6.8-9.2 6.7 3.5-10.9-9.2-6.7h11.4zm64.9 0l3.5 10.9h11.5l-9.3 6.7 3.6 11-9.3-6.8-9.3 6.7 3.6-10.9-9.3-6.7h11.5zM64.9 39.4l3.5 10.9h11.5L70.6 57 74 67.9l-9-6.7-9.3 6.7L59 57l-9-6.7h11.4zm64.8 0l3.6 10.9h11.4l-9.3 6.7 3.6 10.9-9.3-6.7-9.3 6.7L124 57l-9.3-6.7h11.5zm64.9 0l3.5 10.9h11.5l-9.3 6.7 3.5 10.9-9.2-6.7-9.3 6.7 3.5-10.9-9.2-6.7H191zm64.8 0l3.6 10.9h11.4l-9.3 6.7 3.6 10.9-9.3-6.7-9.2 6.7 3.5-10.9-9.3-6.7H256zm64.9 0l3.5 10.9h11.5L330 57l3.5 10.9-9.2-6.7-9.3 6.7 3.5-10.9-9.2-6.7h11.4zM32.4 66.9L36 78h11.4l-9.2 6.7 3.5 10.9-9.3-6.8-9.2 6.8 3.5-11-9.3-6.7H29zm64.9 0l3.5 11h11.5l-9.3 6.7 3.5 10.9-9.2-6.8-9.3 6.8 3.5-11-9.2-6.7h11.4zm64.8 0l3.6 11H177l-9.2 6.7 3.5 10.9-9.3-6.8-9.2 6.8 3.5-11-9.3-6.7h11.5zm64.9 0l3.5 11H242l-9.3 6.7 3.6 10.9-9.3-6.8-9.3 6.8 3.6-11-9.3-6.7h11.4zm64.8 0l3.6 11h11.4l-9.2 6.7 3.5 10.9-9.3-6.8-9.2 6.8 3.5-11-9.2-6.7h11.4zm64.9 0l3.5 11h11.5l-9.3 6.7 3.6 10.9-9.3-6.8-9.3 6.8 3.6-11-9.3-6.7h11.5zM64.9 94.5l3.5 10.9h11.5l-9.3 6.7 3.5 11-9.2-6.8-9.3 6.7 3.5-10.9-9.2-6.7h11.4zm64.8 0l3.6 10.9h11.4l-9.3 6.7 3.6 11-9.3-6.8-9.3 6.7 3.6-10.9-9.3-6.7h11.5zm64.9 0l3.5 10.9h11.5l-9.3 6.7 3.5 11-9.2-6.8-9.3 6.7 3.5-10.9-9.2-6.7H191zm64.8 0l3.6 10.9h11.4l-9.2 6.7 3.5 11-9.3-6.8-9.2 6.7 3.5-10.9-9.3-6.7H256zm64.9 0l3.5 10.9h11.5l-9.3 6.7 3.5 11-9.2-6.8-9.3 6.7 3.5-10.9-9.2-6.7h11.4zM32.4 122.1L36 133h11.4l-9.2 6.7 3.5 11-9.3-6.8-9.2 6.7 3.5-10.9-9.3-6.7H29zm64.9 0l3.5 10.9h11.5l-9.3 6.7 3.5 10.9-9.2-6.7-9.3 6.7 3.5-10.9-9.2-6.7h11.4zm64.8 0l3.6 10.9H177l-9.2 6.7 3.5 11-9.3-6.8-9.2 6.7 3.5-10.9-9.3-6.7h11.5zm64.9 0l3.5 10.9H242l-9.3 6.7 3.6 11-9.3-6.8-9.3 6.7 3.6-10.9-9.3-6.7h11.4zm64.8 0l3.6 10.9h11.4l-9.2 6.7 3.5 11-9.3-6.8-9.2 6.7 3.5-10.9-9.2-6.7h11.4zm64.9 0l3.5 10.9h11.5l-9.3 6.7 3.6 11-9.3-6.8-9.3 6.7 3.6-10.9-9.3-6.7h11.5zM64.9 149.7l3.5 10.9h11.5l-9.3 6.7 3.5 10.9-9.2-6.8-9.3 6.8 3.5-11-9.2-6.7h11.4zm64.8 0l3.6 10.9h11.4l-9.3 6.7 3.6 10.9-9.3-6.8-9.3 6.8 3.6-11-9.3-6.7h11.5zm64.9 0l3.5 10.9h11.5l-9.3 6.7 3.5 10.9-9.2-6.8-9.3 6.8 3.5-11-9.2-6.7H191zm64.8 0l3.6 10.9h11.4l-9.2 6.7 3.5 10.9-9.3-6.8-9.2 6.8 3.5-11-9.3-6.7H256zm64.9 0l3.5 10.9h11.5l-9.3 6.7 3.5 10.9-9.2-6.8-9.3 6.8 3.5-11-9.2-6.7h11.4zM32.4 177.2l3.6 11h11.4l-9.2 6.7 3.5 10.8-9.3-6.7-9.2 6.7 3.5-10.9-9.3-6.7H29zm64.9 0l3.5 11h11.5l-9.3 6.7 3.6 10.8-9.3-6.7-9.3 6.7 3.6-10.9-9.3-6.7h11.4zm64.8 0l3.6 11H177l-9.2 6.7 3.5 10.8-9.3-6.7-9.2 6.7 3.5-10.9-9.3-6.7h11.5zm64.9 0l3.5 11H242l-9.3 6.7 3.6 10.8-9.3-6.7-9.3 6.7 3.6-10.9-9.3-6.7h11.4zm64.8 0l3.6 11h11.4l-9.2 6.7 3.5 10.8-9.3-6.7-9.2 6.7 3.5-10.9-9.2-6.7h11.4zm64.9 0l3.5 11h11.5l-9.3 6.7 3.6 10.8-9.3-6.7-9.3 6.7 3.6-10.9-9.3-6.7h11.5zM64.9 204.8l3.5 10.9h11.5l-9.3 6.7 3.5 11-9.2-6.8-9.3 6.7 3.5-10.9-9.2-6.7h11.4zm64.8 0l3.6 10.9h11.4l-9.3 6.7 3.6 11-9.3-6.8-9.3 6.7 3.6-10.9-9.3-6.7h11.5zm64.9 0l3.5 10.9h11.5l-9.3 6.7 3.5 11-9.2-6.8-9.3 6.7 3.5-10.9-9.2-6.7H191zm64.8 0l3.6 10.9h11.4l-9.2 6.7 3.5 11-9.3-6.8-9.2 6.7 3.5-10.9-9.3-6.7H256zm64.9 0l3.5 10.9h11.5l-9.3 6.7 3.5 11-9.2-6.8-9.3 6.7 3.5-10.9-9.2-6.7h11.4zM32.4 232.4l3.6 10.9h11.4l-9.2 6.7 3.5 10.9-9.3-6.7-9.2 6.7 3.5-11-9.3-6.7H29zm64.9 0l3.5 10.9h11.5L103 250l3.6 10.9-9.3-6.7-9.3 6.7 3.6-11-9.3-6.7h11.4zm64.8 0l3.6 10.9H177l-9 6.7 3.5 10.9-9.3-6.7-9.2 6.7 3.5-11-9.3-6.7h11.5zm64.9 0l3.5 10.9H242l-9.3 6.7 3.6 10.9-9.3-6.7-9.3 6.7 3.6-11-9.3-6.7h11.4zm64.8 0l3.6 10.9h11.4l-9.2 6.7 3.5 10.9-9.3-6.7-9.2 6.7 3.5-11-9.2-6.7h11.4zm64.9 0l3.5 10.9h11.5l-9.3 6.7 3.6 10.9-9.3-6.7-9.3 6.7 3.6-11-9.3-6.7h11.5z"
                                    transform="scale(.9375)"
                                  />
                                </g>
                              </svg>
                              <!-- Selected: "font-semibold", Not Selected: "font-normal" -->
                              <span class="font-normal ml-3 block truncate"> English </span>
                            </div>
                          </li>
                        </ul>
                      </transition>
                    </div>
                  </div>
                  <div>
                    <span v-on:click="langMenu.isOpen = !langMenu.isOpen" class="text-gray-700 group flex items-center px-4 py-3 text-sm hover:bg-gray-100 rounded-b-md">
                      <!-- Heroicon name: outline/logout -->
                      <svg class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                      </svg>
                      {{ $t("profile-menu.sign-out") }}
                    </span>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </header>

      <main class="flex-1 relative overflow-y-auto focus:outline-none">
        <div class="py-6 max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
          <slot name="content"> </slot>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import InputWithIcon from "@/components/form-inputs/InputWithIcon.vue";

export default {
  components: {
    InputWithIcon,
  },
  data() {
    return {
      langMenu: {
        isOpen: false,
      },
      changeCompany: {
        isOpen: false,
        searchField: "",
        form: {
          attrs: {
            id: "search",
            type: "text",
            name: "companySearch",
            placeholder: "Min virksomhed",
            label: "test",
            classes: {
              label: [],
              input: [],
            },
          },
        },
      },
    };
  },
  computed: {
    mainMenu() {
      return this.$store.getters["mainMenu/getMain"];
    },
    profileMenu() {
      return this.$store.getters["mainMenu/getProfile"];
    },
  },
  // created() {
  //   const menu = ;
  //   this.mainMenu = menu.mainMenu;
  //   // console.log(menu);
  // },
  methods: {
    toggleLangMenu() {
      this.langMenu.isOpen = !this.langMenu.isOpen;
    },
    changeLang(locale) {
      this.$store.dispatch("appMetaData/changeLang", { lang: locale, i18n: this.$i18n });
      this.langMenu.isOpen = !this.langMenu.isOpen;
    },
    toggleSubmenu(menuItemName) {
      this.$store.dispatch("mainMenu/toggleSubmenu", menuItemName);
      // this.$store.commit("mainMenu/toggleSubmenu", menuItemName);
    },
    changeCompanyIsOpen() {
      this.changeCompany.isOpen = !this.changeCompany.isOpen;
    },
    profileMenuIsOpen() {
      this.$store.dispatch("mainMenu/toggleProfile");

      // this.profileMenu.isOpen = !this.profileMenu.isOpen;
    },
  },
};
</script>
